import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { isAuthenticated, getUser } from '../services/auth';

import Login from '../pages/Login';
import Cadastro from '../pages/Cadastro';
import EsqueciSenha from '../pages/EsqueciSenha';
import Home from '../pages/Home';
import Figurinha from '../pages/Figurinha';
import Craques from '../pages/Craques';
import Perfil from '../pages/Perfil';
import Cupons from '../pages/Cupons';
import Campeonatos from '../pages/Campeonatos';
import Jogos from '../pages/Jogos';
import Palpites from '../pages/Palpites';
import Ranking from '../pages/Ranking';
import Premiacoes from '../pages/Premiacoes';
import MeusPremios from '../pages/MeusPremios';
import EnviarComprovante from '../pages/EnviarComprovante';
import Admin from '../pages/admin/Admin';
import Layout from '../components/Layout';

function PrivateRoute({ children }) {
  if (!isAuthenticated()) return <Navigate to="/login" replace />;
  return children;
}

function AdminRoute({ children }) {
  if (!isAuthenticated()) return <Navigate to="/login" replace />;
  const user = getUser();
  if (!user || user.tipo_usuario !== 'admin') return <Navigate to="/" replace />;
  return children;
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/cadastro" element={<Cadastro />} />
      <Route path="/esqueceu-senha" element={<EsqueciSenha />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<Home />} />
        <Route path="figurinha" element={<Figurinha />} />
        <Route path="craques" element={<Craques />} />
        <Route path="perfil" element={<Perfil />} />
        <Route path="cupons" element={<Cupons />} />
        <Route path="campeonatos" element={<Campeonatos />} />
        <Route path="jogos" element={<Jogos />} />
        <Route path="palpites" element={<Palpites />} />
        <Route path="ranking" element={<Ranking />} />
        <Route path="premiacoes" element={<Premiacoes />} />
        <Route path="meus-premios" element={<MeusPremios />} />
        <Route path="comprovante" element={<EnviarComprovante />} />
      </Route>
      <Route path="/admin/*" element={<AdminRoute><Admin /></AdminRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
